import React from 'react'

import { EAP_TO_HPI_LINK_DESTINATION } from '@lyrahealth-inc/shared-app-logic'
import { EapToHpiBanner as EapToHpiBannerComponent } from '@lyrahealth-inc/ui-core-crossplatform'

export const EapToHpiBanner: React.FC = () => {
  // TODO: Determining the actual values for these vars
  // will be implemented as part of ACCOUNT-3571
  const sessionsRemaining: number = 0
  const dependentsName: string | undefined = undefined
  const hasHpi: boolean = false
  const hasPaymentInfo: boolean = false

  const onPressLink = (linkDestination: EAP_TO_HPI_LINK_DESTINATION) => {
    // Link locations will depend on EAP status of user and requires that data to navigate
    if (linkDestination == EAP_TO_HPI_LINK_DESTINATION.ADD_HPI) {
      // Navigate to EAP to HPI transition experience add health plan page
    } else if (linkDestination == EAP_TO_HPI_LINK_DESTINATION.ADD_PAYMENT) {
      // Navigate to EAP to HPI transition experience add payment method page
    } else {
      // Navigate to EAP to HPI transition experience overview / confirmation page
    }
  }

  const onClose = () => {
    // TODO: Implement show / hide behavior in ACCOUNT-3571
  }

  return (
    <EapToHpiBannerComponent
      onPressLink={onPressLink}
      onClose={onClose}
      sessionsRemaining={sessionsRemaining}
      dependentsName={dependentsName}
      hasHpi={hasHpi}
      hasPaymentInfo={hasPaymentInfo}
    />
  )
}
